var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUndrawOffRoad3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 219 199.598"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "undraw_off_road_3_svg__a",
  x1: 0.5,
  y1: 1,
  x2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.251
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.122
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.102
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -23)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 233",
  d: "M12.591 98.756c3.205 11.371 9.989 21.214 20.711 25.985 22.283 9.909 72.535 4.8 110.038-1.068 19.4-3.034 36.45-11.405 48.837-23.194z",
  fill: "#6cbbed",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 234",
  d: "M215.216 45.186h-21.045a1.509 1.509 0 110-2.953h3.64a1.509 1.509 0 110-2.953h-2.6a1.509 1.509 0 110-2.953h10.986a34.165 34.165 0 00-8.574-1.919c-29.97-3.13-40.67-1.056-44.445 1.063a47.337 47.337 0 01-15.394 5.482c-18.5 3.1-53.071 6.823-84.409-1.2-15.575-3.984-27.152 2.749-34.091 14h199.59a22.324 22.324 0 00-2.473-8.935 2.068 2.068 0 01-1.185.369z",
  fill: "#6cbbed",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 235",
  d: "M10.215 75a61.405 61.405 0 00.816 19.855l184.711 5.49a71.189 71.189 0 0012.833-15.9zm73.056 14.164h-3.629a1.508 1.508 0 110 2.953H58.613a1.509 1.509 0 110-2.953h3.635a1.509 1.509 0 110-2.953h-2.613a1.509 1.509 0 110-2.953h21.039a1.509 1.509 0 110 2.953h2.6a1.509 1.509 0 110 2.953z",
  fill: "#6cbbed",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 236",
  d: "M218.907 53.862L15.246 57.848a54.853 54.853 0 00-4.877 16.925h204.969a58.522 58.522 0 002.95-10.788 40.926 40.926 0 00.619-10.123zM51.72 66.923h-3.673a1.512 1.512 0 110 2.953H26.81a1.512 1.512 0 110-2.953h3.673a1.512 1.512 0 110-2.953H27.85a1.512 1.512 0 110-2.953h21.237a1.511 1.511 0 110 2.953h2.623a1.511 1.511 0 11.01 2.953z",
  fill: "#6cbbed",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 237",
  d: "M145.566 171.908a3.575 3.575 0 01-4.387 0c-.613-4.043.942-11.988 1.309-13.78l.076-.359h1.772a1.23 1.23 0 01.273.411c1.203 2.591.957 13.728.957 13.728z",
  fill: "#535f89"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 238",
  d: "M143.964 156.14v1.631h-.738v-1.631a2.147 2.147 0 01.359-.03 2.417 2.417 0 01.379.03z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 239",
  d: "M144.597 158.187a2.09 2.09 0 01-1.014.246 2.006 2.006 0 01-1.09-.29l.076-.359h1.767a1.23 1.23 0 01.261.403z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 30",
  cx: 1.479,
  cy: 0.878,
  rx: 1.479,
  ry: 0.878,
  transform: "translate(142.104 156.391)",
  fill: "#dce2ed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 249",
  d: "M198.395 178.263a2.362 2.362 0 01-2.9 0c-.406-2.672.623-7.928.864-9.1l.052-.246h1.163a.823.823 0 01.182.271c.799 1.715.639 9.075.639 9.075z",
  fill: "#535f89"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 250",
  d: "M197.332 167.841v1.08h-.492v-1.08a1.232 1.232 0 01.246-.02 1.653 1.653 0 01.246.02z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 251",
  d: "M197.753 169.182a1.4 1.4 0 01-.672.158 1.354 1.354 0 01-.721-.19l.052-.246h1.159a.821.821 0 01.182.278z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 32",
  cx: 0.977,
  cy: 0.581,
  rx: 0.977,
  ry: 0.581,
  transform: "translate(196.104 168.005)",
  fill: "#dce2ed"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 34",
  cx: 109.5,
  cy: 10.827,
  rx: 109.5,
  ry: 10.827,
  transform: "translate(0 200.944)",
  fill: "#6cbbed",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 262",
  d: "M97.659 181.963a11.048 11.048 0 00-7.458-.933 44.961 44.961 0 01-11.5.335",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 263",
  d: "M83.882 131.322s-1.048 16.531.814 19.791z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 264",
  d: "M80.014 151.113s1.344 15.483 2.274 18.509-2.274-18.509-2.274-18.509z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 265",
  d: "M78.705 113.044c-.952.349-5.027 8.612-4.21 11.061s4.21-11.061 4.21-11.061z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 266",
  d: "M89.035 104.466c-.44.2-2.338 4.961-1.969 6.368s1.969-6.368 1.969-6.368z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 267",
  d: "M71.392 132.225a61.952 61.952 0 01.428 11.787 45.45 45.45 0 00.128 8.964",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 270",
  d: "M62.587 23a5.465 5.465 0 001.085 1.452c.384.364.822.674 1.169 1.073a8.505 8.505 0 01.738 1.1 29.215 29.215 0 003.128 3.937",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 272",
  d: "M76.936 71.739a10.073 10.073 0 011.9 1.307 3.406 3.406 0 011.1 1.969c.042.327.02.662.094.984a3.106 3.106 0 00.647 1.189 16.338 16.338 0 001.6 1.774",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 273",
  d: "M82.458 93.806a11.557 11.557 0 00-1.531-1.063 6.357 6.357 0 00-1.572-.691 16.82 16.82 0 00-2.6-.281 3.608 3.608 0 01-2.367-.984",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 274",
  d: "M48.072 83.122a6.964 6.964 0 013.012.536c.468.246.874.586 1.331.842a4.026 4.026 0 001.941.5",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 275",
  d: "M62.338 87.369a.571.571 0 00-.738.172c-.182.212-.283.492-.472.689a2.131 2.131 0 01-1.543.472",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 276",
  d: "M68.222 65.511l.984.519a17.489 17.489 0 012.921 1.772",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 279",
  d: "M56.79 174.007a4.459 4.459 0 01-5.475 0c-.763-5.047 1.176-14.966 1.634-17.19l.1-.45h2.19a1.621 1.621 0 01.342.512c1.512 3.227 1.209 17.128 1.209 17.128z",
  fill: "#535f89"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 280",
  d: "M54.785 154.329v2.037h-.923v-2.04a2.681 2.681 0 01.45-.034 2.959 2.959 0 01.473.037z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 281",
  d: "M55.577 156.878a2.618 2.618 0 01-1.265.3 2.524 2.524 0 01-1.363-.359l.1-.45h2.19a1.62 1.62 0 01.338.509z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 35",
  cx: 1.846,
  cy: 1.095,
  rx: 1.846,
  ry: 1.095,
  transform: "translate(52.467 154.639)",
  fill: "#dce2ed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 298",
  d: "M163.089 149.363a6.339 6.339 0 014.279-.534 26.155 26.155 0 006.611.191",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 299",
  d: "M171.003 120.278s.6 9.5-.468 11.366z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 300",
  d: "M173.226 131.644s-.77 8.893-1.3 10.633 1.3-10.633 1.3-10.633z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 301",
  d: "M173.975 109.781c.546.2 2.886 4.948 2.419 6.351s-2.419-6.351-2.419-6.351z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 302",
  d: "M168.042 104.855c.246.113 1.344 2.849 1.125 3.657s-1.125-3.657-1.125-3.657z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 303",
  d: "M178.175 120.797a36.128 36.128 0 00-.246 6.769 25.937 25.937 0 01-.074 5.148",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 304",
  d: "M148.871 88.695a2.214 2.214 0 01.458 1.4c.017.492-.049 1-.017 1.5s.285 1.139.807 1.211",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 306",
  d: "M183.232 58.065a3.185 3.185 0 01-.623.834c-.221.209-.472.386-.672.615a4.854 4.854 0 00-.431.632 17.1 17.1 0 01-1.794 2.269",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 308",
  d: "M174.992 86.05a5.839 5.839 0 00-1.09.738 1.954 1.954 0 00-.632 1.137c-.025.187-.012.379-.054.564a1.8 1.8 0 01-.372.682 9.242 9.242 0 01-.92 1.019",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 309",
  d: "M171.819 98.732a6.91 6.91 0 01.878-.61 3.715 3.715 0 01.906-.4 9.739 9.739 0 011.491-.148 2.113 2.113 0 001.361-.559",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 310",
  d: "M191.581 92.595a3.944 3.944 0 00-1.722.308c-.268.138-.492.337-.765.492a2.3 2.3 0 01-1.115.29",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 311",
  d: "M183.375 95.034a.332.332 0 01.426.1c.106.121.162.278.273.4a1.21 1.21 0 00.883.271",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 312",
  d: "M179.997 82.482l-.568.3a10.073 10.073 0 00-1.673 1.021",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 313",
  d: "M173.507 88.034c-.374-.089-.7.31-.763.689s0 .775-.1 1.144a2.14 2.14 0 01-.558.839",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 315",
  d: "M93.774 109.072c-4.04 5.448-7.367 21.474-8.3 26.3l-7.038-.278c.443-4.156 8.952-20.938 11.319-25.542a147.9 147.9 0 014.019-.48z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 28",
  fill: "#dce0ed",
  d: "M178.579 107.138h3.12v4.395h-3.12z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 316",
  d: "M181.699 107.138v1.43a2.4 2.4 0 01-.677.091l-2.441-.02v-1.5z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 317",
  d: "M177.263 95.942h2.953a3.536 3.536 0 013.275 2.215 9.986 9.986 0 01-.327 8.858 2.431 2.431 0 01-2.133 1.23l-3.76-.032z",
  fill: "#dce0ed"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 40",
  cx: 3.155,
  cy: 6.134,
  rx: 3.155,
  ry: 6.134,
  transform: "translate(174.108 95.944)",
  fill: "#f0f0f4"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 29",
  fill: "#dce0ed",
  d: "M150.872 107.19h3.12v3.846h-3.12z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 318",
  d: "M153.992 107.19v1.23a2.408 2.408 0 01-.679.091l-2.441-.022v-1.292z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 319",
  d: "M149.555 95.996h2.953a3.529 3.529 0 013.273 2.215 9.977 9.977 0 01-.325 8.858 2.436 2.436 0 01-2.136 1.23l-3.758-.034z",
  fill: "#dce0ed"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 41",
  cx: 3.155,
  cy: 6.134,
  rx: 3.155,
  ry: 6.134,
  transform: "translate(146.401 95.996)",
  fill: "#f0f0f4"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 320",
  d: "M150.343 98.238s-1.164.187-.559 1.722a10.5 10.5 0 01.7 2.325s1.164.605 1.117-1.4a2.991 2.991 0 00-1.258-2.647z",
  fill: "#dce0ed"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 42",
  cx: 18.403,
  cy: 20.17,
  rx: 18.403,
  ry: 20.17,
  transform: "translate(13.733 165.727)",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 321",
  d: "M39.032 166.984c-9.629.647-17.257 9.412-17.257 20.131 0 8.639 4.956 16.009 11.922 18.881 9.631-.647 17.259-9.412 17.259-20.131-.001-8.64-4.958-16.009-11.924-18.881z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 43",
  cx: 14.936,
  cy: 19.476,
  rx: 14.936,
  ry: 19.476,
  transform: "translate(161.234 122.335)",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 322",
  d: "M171.997 123.15c-6.2 2.375-10.719 9.843-10.719 18.689 0 9.454 5.167 17.333 12.018 19.1 6.194-2.375 10.719-9.843 10.719-18.689 0-9.449-5.168-17.33-12.018-19.1z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 323",
  d: "M120.061 137.653l.278-7.07s-1.388-3.051-2.773-3.327-4.574-.45-4.574-.45-2.5 10.153-.832 13.2 7.901-2.353 7.901-2.353z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 324",
  d: "M120.061 137.653l.278-7.07s-1.388-3.051-2.773-3.327-4.574-.45-4.574-.45-2.5 10.153-.832 13.2 7.901-2.353 7.901-2.353z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 325",
  d: "M94.485 136.891s-.859-9.8 4.528-9.98c.694-.022 1.388-.039 2.079-.106 3.733-.362 13.918-1.147 12.7 1.179 0 0-2.426 8.526-.763 10.674z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 326",
  d: "M170.835 155.067l7.224.209s1.248-13.31 1.663-14.348.625-6.031-.726-6.757a34.934 34.934 0 00-5.87-1.612l-3.332 7.586-.258 6.863z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 327",
  d: "M170.835 155.067l7.224.209s1.248-13.31 1.663-14.348.625-6.031-.726-6.757a34.934 34.934 0 00-5.87-1.612l-3.332 7.586-.258 6.863z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 328",
  d: "M153.367 132.975l-.032-1.476a.854.854 0 01.891-.871c3.583.15 16.615.775 18.9 1.939 0 0-2.5 18.558.261 22.978l-.94 14.865-31.92-2.392z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 329",
  d: "M150.872 109.538a156.17 156.17 0 013.12-.276v1.774h-3.12z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 330",
  d: "M181.699 111.307v.224h-3.118v-1.349a13.318 13.318 0 013.118 1.125z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 331",
  d: "M334.51 483.276a.29.29 0 01.118-.185.416.416 0 01.214-.02v.125a4.813 4.813 0 00-.445.455c.044-.124.076-.251.113-.375zm11.292-3.312a.384.384 0 000-.052 10.894 10.894 0 01.539-1.152 11.2 11.2 0 00-.541 1.204zm1.683-3.184c-.266.4-.588.908-.906 1.5a6.973 6.973 0 01.906-1.5zm-43.965 34.435c1.252.049 2.3.027 2.3.027a9.213 9.213 0 01-2.3-.027zm2.3.025a2.622 2.622 0 011.59-.192 4.382 4.382 0 00-1.592.191zm42.031-18.928l.458-7.874s-.17 4.021-.113 5.76a5.659 5.659 0 01-.344 2.116z",
  transform: "translate(-240.751 -350.222)",
  fill: "url(#undraw_off_road_3_svg__a)"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 332",
  d: "M80.912 157.17s-.13.4-.3.915a11.952 11.952 0 01-.812 2.074 11.709 11.709 0 01-2.325.246 7.19 7.19 0 01-4.9-1.558s.6-.431 1.23-.93a6.959 6.959 0 001.432-1.344 6.658 6.658 0 011.924-1.408c.293-.167.492-.276.492-.276z",
  fill: "#f899a5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 333",
  d: "M79.529 160.646s-11.506-.529-12.193-.682a1.227 1.227 0 01-.827-.96c-.229-.536.984-.421.984-.421.123.02 1.476.246 2.751.409a8.384 8.384 0 002.215.123 4.347 4.347 0 011.54-.123 3.648 3.648 0 00-3.105-2.5l.047-.047a3.87 3.87 0 01.657-.492c2.345.1 3.585 3.329 3.585 3.329h.02c.266.084 3.093.96 3.654 1.041.586.094.672.323.672.323z",
  fill: "#f3b4b4"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 334",
  d: "M73.513 161.672c-.044.145-.246.246-.576.273a3.729 3.729 0 01-.536 0 12.188 12.188 0 01-3.2-.718 8.597 8.597 0 00-.507-.162h-.02a6.966 6.966 0 00-1.2-.246 2.444 2.444 0 00-1.533.192s-1.009.022-2.215-.027a18 18 0 01-2.763-.29c-.13-.027-.246-.059-.367-.091a2.56 2.56 0 01-.618-.246c-1.27-.763 3.007-1.277 3.007-1.277a2.23 2.23 0 001.294-.625l.044-.049.108-.108a5.893 5.893 0 01.519-.4l.157-.106c.851-.576 2-1.191 2-1.191a4.858 4.858 0 002.119-1.211 2.508 2.508 0 00.3-.349l2.365-.61 1.629 3.912s.012.212.025.529a18.6 18.6 0 01-.032 2.8z",
  fill: "#f899a5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 335",
  d: "M72.937 161.945a3.729 3.729 0 01-.536 0 12.188 12.188 0 01-3.2-.718 8.597 8.597 0 00-.507-.162h-.02a6.976 6.976 0 00-1.2-.246 2.445 2.445 0 00-1.533.192s-1.009.022-2.215-.027a18 18 0 01-2.763-.29c-.13-.027-.246-.059-.367-.091a2.926 2.926 0 01.475-.02c.121.015 1.489.182 2.763.288a8.345 8.345 0 002.215.027 4.131 4.131 0 011.533-.192 3.656 3.656 0 00-3.211-2.36c.015-.017.032-.032.044-.049a4.062 4.062 0 01.627-.512h.049c2.315.037 3.679 3.167 3.679 3.167h.02c.268.071 3.132.827 3.691.883a1.412 1.412 0 01.456.11z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 336",
  d: "M73.072 162.237s-11.518-.03-12.21-.15-.869-.925-.869-.925c-.246-.524.957-.46.957-.46.121.015 1.476.182 2.763.29a8.57 8.57 0 002.215.027 4.111 4.111 0 011.533-.192 3.659 3.659 0 00-3.211-2.36l.044-.049a4.207 4.207 0 01.635-.519c2.348 0 3.728 3.169 3.728 3.169h.02c.268.069 3.132.824 3.691.881.608.062.704.288.704.288z",
  fill: "#f3b4b4"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 337",
  d: "M80.912 157.168s-.13.4-.3.915a21.861 21.861 0 01-3.2-2.544 1.873 1.873 0 01-.261-.367c.293-.167.492-.276.492-.276z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 338",
  d: "M87.541 152.179l-.408 1.321-3.913 2.131a6 6 0 00-1.23 1.1 1.1 1.1 0 01-.625.492 8.677 8.677 0 00-.541.753 21.874 21.874 0 01-3.2-2.544c-.271-.31-.4-.571-.278-.716a41.094 41.094 0 013.583-2.825s1.875-2.461 1.956-2.416a12.443 12.443 0 001.577-1.378l.379-.354z",
  fill: "#bdd3e8"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 339",
  d: "M106.195 125.576l-3.809 6.737-1.4 2.665-7.444-1.085.167-.357.63-1.321.288-.605.044-.081.824-1.494.047-.062.6-.846 1.2-1.7a1.088 1.088 0 00.394-.1.93.93 0 00.45-.512c.426-1.053-.354-3.078-.354-3.078s2.825-6.89 3.8-3.1a7.218 7.218 0 003.937 4.675 5.426 5.426 0 00.626.264z",
  fill: "#f899a5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 340",
  d: "M93.4 148.738v.652s2.461 2.355 2.136 4.274a11.622 11.622 0 00.362 4.311l2.475-.177-.374-8.77z",
  fill: "#bdd3e8"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 341",
  d: "M98.373 157.798l-2.475.177a11.613 11.613 0 01-.362-4.311c.325-1.922-2.136-4.274-2.136-4.274v-.652l4.6.29.025.571z",
  opacity: 0.05
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 342",
  d: "M84.667 148.486a20.671 20.671 0 00-2.17 2.355c-.871 1.159-2.355 2.825-2.355 2.825l-1.774 1.051-.738.716c-.271-.31-.4-.571-.278-.716a41.089 41.089 0 013.583-2.825s1.875-2.461 1.956-2.416a12.449 12.449 0 001.577-1.378z",
  opacity: 0.05
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 343",
  d: "M73.538 158.867a2.388 2.388 0 00-.2.2s-.037 1.156-.942-1.56-3.152-2.065-3.152-2.065a.042.042 0 01-.017-.049c0-.074.13-.2.3-.349l2.365-.61 1.629 3.912s.005.203.017.521z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 344",
  d: "M81.882 143.413l-1.378.037-.942 1.341s-1.558 1.666-2.028 2.082a31.981 31.981 0 00-4.382 4.764s-.8.4-.8.8-1.521 1.558-1.521 1.558-1.595 1.085-1.378 1.23c0 0 2.247-.652 3.152 2.064s.942 1.558.942 1.558a2.114 2.114 0 01.544-.428c.217-.079 1.248-1.563 1.565-1.6a1.566 1.566 0 00.645-.29l1.845-1.811 1.777-1.051s1.476-1.666 2.352-2.825a20.829 20.829 0 012.173-2.355z",
  fill: "#bdd3e8"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 345",
  d: "M74.999 152.181s2.461 1.193 2.355 1.447-2.355-1.447-2.355-1.447z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 346",
  d: "M76.943 151.89s.192 1.075 1.171 1.026-1.171-1.026-1.171-1.026z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 347",
  d: "M73.513 154.91a1.112 1.112 0 001.051.723c.905.109-1.051-.723-1.051-.723z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 348",
  d: "M82.733 152.181s1.193.492 1.3 1.176-1.3-1.176-1.3-1.176z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 349",
  d: "M79.797 154.715a6.635 6.635 0 011.767 1.855 16.641 16.641 0 01-1.767-1.855z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 350",
  d: "M81.916 153.655a.8.8 0 01.817.172c.332.344-.817-.172-.817-.172z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 351",
  d: "M90.693 141.822s-4.619-1.5-4.264 0 4.264 2.335 4.264 2.335z",
  fill: "#f899a5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 352",
  d: "M106.195 125.575l-3.809 6.737-1.4 2.665-7.444-1.085.167-.357a4.293 4.293 0 01.593-.664 2.46 2.46 0 01.037-.657 1.277 1.277 0 01.332-.687l.03-.027a4.591 4.591 0 00.841-1.528c.064-.17.1-.283.1-.283l.492-.563 1.6-1.8.45-.512.423-.477-1.516 2.156s-.723 1.3-.76 1.476-1.23 1.774-1.23 1.774-2.028 1.777 1.594 1.811 5.832-3.494 5.832-3.494l3.056-4.734a5.409 5.409 0 00.612.249z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 353",
  d: "M98.024 149.6l-1.42-.1-3.206-.268v-.491l4.6.288z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 354",
  d: "M105.57 124.941a2.413 2.413 0 001.3.76 8.706 8.706 0 00-1.631 2.5s-2.033 3.42-.578 4.6a7.41 7.41 0 002.3 1.412l-.44 7.874s1.075 5.413 1.476 5.817a1.881 1.881 0 01.29 1.3s-.263.906.012 1.23a6.263 6.263 0 01.349 1.993 11.388 11.388 0 00-1.969-.834c-.34 0-1.23-1.7-1.23-1.7l-8.858-.615-3.9-.325.615-10.827s-1.774-2.911.652-5.15a1.846 1.846 0 01.4-1.371 5.624 5.624 0 00.942-1.811l2.97-3.356-1.521 2.163s-.726 1.3-.76 1.476-1.23 1.777-1.23 1.777-2.028 1.774 1.595 1.811 5.832-3.514 5.832-3.514z",
  fill: "#e6ebef"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 355",
  d: "M102.672 139.213a5.365 5.365 0 002.608.96c1.349.037-2.608-.96-2.608-.96z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 356",
  d: "M104.301 136.288s1-.492 1.558-.081-1.558.081-1.558.081z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 357",
  d: "M103.831 137.931s.064.581 1.54.652-1.54-.652-1.54-.652z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 358",
  d: "M106.764 125.701l.31.165a6.914 6.914 0 001.954.416 3.127 3.127 0 012.554 2.443c.054.285.1.667.135 1.075a22.081 22.081 0 01-.069 4.429 14.072 14.072 0 00-.175 2.387c.108.325-.6 5.379-.6 5.379s-.162 4.129-1.2 4.51-6.791.379-6.791.379l-2.443-4.237 5.7.271a5.581 5.581 0 00.706-2.933c-.054-1.74.108-5.76.108-5.76s-3.445-.738-2.746-3.428a16.483 16.483 0 012.557-5.096z",
  fill: "#f899a5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 359",
  d: "M95.898 157.976s-2.3.76-3.2.362a22.072 22.072 0 01-2.852-1.919s-1.255-1.23-2.448-2.606l-.153-.177c-1.033-1.2-1.969-2.461-1.969-3.083a2.619 2.619 0 00-.1-.765 3.2 3.2 0 00-.492-1 2.992 2.992 0 00-.423-.477l-3.767-4.855s1.088-1.159 1.088-1.476a2.151 2.151 0 012.97-1.157 36.014 36.014 0 014.085 3.43c2.35 2.156 4.754 4.5 4.754 4.5s.17.182.418.465a8.869 8.869 0 011.88 2.832c.14.964.209 5.926.209 5.926z",
  fill: "#bdd3e8"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 360",
  d: "M93.819 149.203c-1.784 1.777-4.469 4.159-6.417 4.609l-.052.012-.1-.189-2.057-3.849-.522-.984.027-.027 3.952-4.545c2.35 2.156 4.754 4.5 4.754 4.5z",
  opacity: 0.05
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 361",
  d: "M108.241 152.532v.824s1.142 4.031-.923 5.167c-1.043.578-3.265.716-5.209.711a5.517 5.517 0 01-5.445-4.54 3.3 3.3 0 01-.022-1.169s-.923-6.6-1.142-6.644c0 0-5.19 5.942-8.366 6.627l-2.682-5.015 4.284-4.921s3.179-5.052 4.1-5.514a6.67 6.67 0 001.848-1.757s3.723-3.105 6.194 2.138 4.075 9.479 4.675 11.051c0 0 .871 1.782 1.412 1.777h.017a1.27 1.27 0 011.257 1.265z",
  fill: "#bdd3e8"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 362",
  d: "M95.391 146.602a5.369 5.369 0 001.112-1.9c.411-1.2-.123 1.213-1 2.173z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 363",
  d: "M90.556 116.704a1.81 1.81 0 00.561.94 17.97 17.97 0 001.816 1.71 1.885 1.885 0 01.664.765 1.2 1.2 0 01-.044.664 11.392 11.392 0 01-.965 2.4 1.476 1.476 0 00-.268.817c.066.645.984 1.006 1.654 1.432a2.692 2.692 0 011.353 2.284c-.054 1.336-1.321 2.49-1.619 3.809a6.4 6.4 0 002.394-.492 1.8 1.8 0 001.2-1.526.431.431 0 01.037-.283.608.608 0 01.345-.177c.657-.16 1.459-.108 1.941-.475s.372-1.011.165-1.526c-.561-1.408-1.373-2.761-1.863-4.183a3 3 0 01-.212-1.5 5.017 5.017 0 01.65-1.43 9.1 9.1 0 001.078-3.283 3.057 3.057 0 00-.266-1.927 3.247 3.247 0 00-2.148-1.422c-1.848-.406-2.832.492-4.277 1.09-1.074.458-2.305 1.278-2.196 2.313z",
  fill: "#4b3648"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 364",
  d: "M93.708 131.41c.15 0 .3-.017.45-.03.308-1.307 1.555-2.461 1.609-3.777a2.7 2.7 0 00-1.353-2.286c-.659-.426-1.587-.787-1.654-1.43a1.489 1.489 0 01.268-.819 11.388 11.388 0 00.965-2.4 1.2 1.2 0 00.044-.664 1.864 1.864 0 00-.664-.763 18.274 18.274 0 01-1.816-1.722 1.794 1.794 0 01-.561-.937c-.113-1.034 1.11-1.855 2.2-2.311a9.3 9.3 0 013.184-1.186c-1.447-.094-2.36.655-3.625 1.186-1.088.455-2.311 1.277-2.2 2.311a1.794 1.794 0 00.561.938 18.281 18.281 0 001.816 1.723 1.863 1.863 0 01.664.763 1.2 1.2 0 01-.044.664 11.388 11.388 0 01-.965 2.4 1.489 1.489 0 00-.268.819c.066.642.984 1 1.654 1.43a2.7 2.7 0 011.353 2.286c-.053 1.332-1.321 2.488-1.618 3.805z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 44",
  cx: 5.788,
  cy: 5.788,
  r: 5.788,
  transform: "translate(92.066 113.774)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 45",
  cx: 5.788,
  cy: 5.788,
  r: 5.788,
  transform: "translate(92.175 113.558)",
  fill: "#f899a5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 365",
  d: "M94.399 116.631a2.294 2.294 0 01-1.23-.7 1.15 1.15 0 01.03-1.454 2.544 2.544 0 01.7-.3c.972-.431 1.137-1.939 1.8-2.881a2.161 2.161 0 011.993-.96 9.6 9.6 0 011.2.354c.962.261 1.991.054 2.968.231 1.919.352 3.388 2.158 4.183 4.183.367.933.623 1.919.913 2.891a38.288 38.288 0 001.575 4.282 3.009 3.009 0 00.539.908c.615.628 1.7.581 2.082 1.425a2.991 2.991 0 01.042 1.57 12.49 12.49 0 00.453 5.322c.416 1.319 1.211 2.653 2.424 2.842a1.348 1.348 0 01-1.951.123 6.381 6.381 0 01-1.307-1.895 12.059 12.059 0 00-1.115-1.636 2.3 2.3 0 00-.844-.726c-.827-.335-1.705.349-2.443.945a4.207 4.207 0 01-1.991 1.046 1.6 1.6 0 01-1.759-1.08c-.278-.942.283-2.215-.33-2.9a4.374 4.374 0 00-.812-.527c-.782-.556-.878-1.828-.773-2.906a6.5 6.5 0 00-.091-3.182 3.831 3.831 0 00-.984-1.23 21.654 21.654 0 00-5.945-3.9",
  fill: "#4b3648"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 69",
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 366",
  d: "M105.036 132.026a1.6 1.6 0 01-1.762-1.08c-.278-.94.285-2.215-.33-2.9a4.3 4.3 0 00-.81-.524c-.785-.556-.881-1.828-.773-2.906a6.445 6.445 0 00-.093-3.184 3.858 3.858 0 00-.984-1.23 21.654 21.654 0 00-5.945-3.925l.684.162a2.3 2.3 0 01-1.23-.7 1.154 1.154 0 01.032-1.457 2.524 2.524 0 01.694-.3c.984-.431 1.137-1.939 1.8-2.881a2.377 2.377 0 01.829-.738 2.262 2.262 0 00-1.489.952c-.659.942-.822 2.461-1.8 2.881a2.545 2.545 0 00-.7.3 1.141 1.141 0 00-.03 1.454 2.374 2.374 0 001.23.7l-.682-.16a21.655 21.655 0 015.943 3.917 3.831 3.831 0 01.984 1.23 6.436 6.436 0 01.091 3.182c-.108 1.078 0 2.35.773 2.906a4.135 4.135 0 01.812.527c.613.687.052 1.956.33 2.9a1.6 1.6 0 001.759 1.08 2.555 2.555 0 00.792-.246 1.213 1.213 0 01-.125.04z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 367",
  d: "M112.734 134.28a6.348 6.348 0 01-1.3-1.892 11.694 11.694 0 00-1.117-1.636 2.259 2.259 0 00-.844-.726 1.526 1.526 0 00-1.294.143 1.252 1.252 0 01.635.076 2.281 2.281 0 01.844.726 12.06 12.06 0 011.115 1.636 6.519 6.519 0 001.307 1.895 1.436 1.436 0 001.7.135 1.6 1.6 0 01-1.036-.357z"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 368",
  d: "M197.347 155.537l-4.715.069-9.739-17.7-1.626-2.955 1.248-7.485.96 1.811z",
  fill: "#dce0ed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 369",
  d: "M154.717 133.772l-1.939 2.911-5.8-7.845-2.655-3.593 1.594-2.148 1.221 1.481z",
  fill: "#dce0ed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 370",
  d: "M147.136 124.578c0 .15.017.305.027.46l-.187 3.8-2.655-3.593 1.595-2.148z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 371",
  d: "M183.473 129.277l-.581 8.63-1.626-2.955 1.248-7.485z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 372",
  d: "M141.625 130.099s-2.328-17.385 6.152-19.986a2.147 2.147 0 01.332-.069c1.951-.234 20.128-2.33 29.565.16 0 0 6.447.972 6.378 4.429l-2.859 42.358h-4.643l1.523-28s2.215-12.2-1.454-13.042-20.379-2.215-26.27-.554c0 0-4.3-.972-3.6 9.634l-.278 5.684z",
  fill: "#dce0ed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 373",
  d: "M155.756 135.261a2.677 2.677 0 00-1.093-2.392c-1.3-.984-5.3-3.118-5.3-3.118l-1.3.1-3.9 9.67.258 20.534 7.018 8.681z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 374",
  d: "M155.756 135.261a2.677 2.677 0 00-1.093-2.392c-1.3-.984-5.3-3.118-5.3-3.118l-1.3.1-3.9 9.67.258 20.534 7.018 8.681z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 375",
  d: "M127.756 156.784l.138-21.073s-.623-8.179 4.264-8.317c0 0 11.523.084 16.531 1.71a1.117 1.117 0 01.63 1.614c-.984 1.735-2.677 6.329-3.489 18.111v12.633z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 376",
  d: "M152.063 170.25l-20.97-.49h-.02l-10.305-.239 1.195-13.777 5.719.209 18.2 4.055 5.561 8.733z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 377",
  d: "M152.063 170.25l-20.97-.49h-.02l-10.305-.239 1.195-13.777 5.719.209 18.2 4.055 5.561 8.733z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 378",
  d: "M152.067 170.249l-20.97-.49-.344-9.232 15.128-.519 5.561 8.733z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 379",
  d: "M131.078 169.76l-10.305-.246 1.2-13.78s3.223 5.148 8.785 4.784z",
  fill: "#fff",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 380",
  d: "M205.039 180.904c-.416 3.952-3.224 3.327-3.224 3.327l-.524-.047-5.194-.472.209-6.134a22.608 22.608 0 015.268.317c1.951.403 3.652 1.255 3.465 3.009z",
  fill: "#dce0ed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 381",
  d: "M132.884 121.019s-9.565 4.363-10.259 5.613-5.414 6.644-5.414 6.644l2.045 3.445 9.461-7.522z",
  fill: "#4c4981"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 382",
  d: "M125.595 143.325l-4.429-.662-3.258 3.844s-4.54 2.252-5.069 3.236-2.18 3.868-2.909 3.89-1.41 1.085-1.415 1.506-2.773 5.254-3.46 5.532a4.809 4.809 0 00-1.848 2.158 28.8 28.8 0 01-2.584 3.4s-4.429 6.932-5.089 7.153-3.211 4.7-3.858 5.229-2.461 1.009-2.239 1.439 4.675 6.518 4.4 8.243c0 0 3.315-2.623 3.445-3.43s4.232-5.064 4.232-5.064l21.484-22.313 4.141-14.063z",
  fill: "#ceddf9"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 383",
  d: "M137.49 150.493s.883 10.143-2.045 11.678-4.921 1.358-5.485 2.035-4 1.275-4.36 1.89-9.983 5.992-9.983 5.992-6.58 3.878-7.611 4.722-6.644 3.312-7.6 4.473-6.966 4.968-6.966 4.968-1.759-5.413-3.782-5.888c0 0 4.862-.957 5.15-1.722s1.74-1.587 1.74-1.587 6.922-4.016 7.136-4.921 1.919-2.195 1.919-2.195 2.749-3.757 3.76-4.119 7.008-6.518 7.008-6.518 4.077-2.156 4.53-2.864 8.179-4.724 8.179-4.724l-8.807-10.943 2.785-.856 8.251 2.215 1.476 2.675z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 384",
  d: "M137.987 150.641s.886 10.143-2.042 11.678-4.921 1.361-5.487 2.035-4 1.277-4.36 1.89-9.981 5.994-9.981 5.994-6.58 3.876-7.613 4.712-6.644 3.315-7.6 4.476-6.966 4.966-6.966 4.966-1.767-5.4-3.782-5.891c0 0 4.865-.955 5.15-1.722s1.74-1.59 1.74-1.59 6.922-4.016 7.136-4.921 1.922-2.2 1.922-2.2 2.749-3.757 3.76-4.117 7.006-6.521 7.006-6.521 4.077-2.156 4.53-2.864-3.494-10.089-3.494-10.089l2.874-5.586 2.785-.854 8.251 2.215 1.476 2.675z",
  fill: "#ceddf9"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 385",
  d: "M147.779 124.095l-6.73 4.675s-8.133-3.017-4.921-4.227c2.106-.795 2.864-4.9 3.135-7.628.143-1.422.15-2.461.15-2.461s9.176-.015 7.488 2.913a4.608 4.608 0 00-.561 2.648 9.173 9.173 0 001.439 4.08z",
  fill: "#fec2be"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 386",
  d: "M146.327 120.017a6.452 6.452 0 01-7.077-3.093c.143-1.422.15-2.461.15-2.461s9.176-.015 7.488 2.913a4.609 4.609 0 00-.561 2.641z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 387",
  d: "M151.085 115.416a6.466 6.466 0 11.145-.593 6.398 6.398 0 01-.145.593z",
  fill: "#fec2be"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 388",
  d: "M138.165 121.471s-1.129 0-1.2 1.607-1.213 1.489-1.213 1.489l-5.305 5.509s-2.382 5.7-2.362 5.935-.536 1.2-.411 1.683-.049 1.969-.492 1.838a1.047 1.047 0 00-1.171 1.051c.01.726-3.728 2.953-3.575 3.494s10.642 6.115 10.642 6.115l4.365 3.383 4.075-7.591 3.4-10.46 1.887-6.073 1.563-1.747-.719-4.1s-.645-1.774-1.171-1.526-2.461 2.338-4.277 2.52-2.877.4-3.3 0-3.003-.693-.736-3.127z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 389",
  d: "M138.526 120.938a1.542 1.542 0 00-1.417 1.644c-.074 1.6-1.213 1.489-1.213 1.489l-5.305 5.509s-2.382 5.7-2.36 5.935-.539 1.193-.413 1.683-.047 1.969-.492 1.838a1.048 1.048 0 00-1.174 1.051c.01.726-3.728 2.953-3.573 3.494s10.64 6.115 10.64 6.115l4.368 3.383 4.075-7.594 3.4-10.46 1.9-6.07 1.56-1.747-.719-4.1s-.645-1.774-1.171-1.526-2.461 2.338-4.274 2.517-2.877.406-3.3 0-.17-.863-.532-3.161z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 390",
  d: "M138.477 121.102a1.541 1.541 0 00-1.417 1.644c-.071 1.6-1.213 1.491-1.213 1.491l-5.305 5.507s-2.382 5.7-2.36 5.935-.539 1.2-.413 1.683-.047 1.969-.492 1.838a1.046 1.046 0 00-1.171 1.051c.01.726-3.728 2.953-3.573 3.494s10.64 6.117 10.64 6.117l4.365 3.381 4.075-7.591 3.4-10.46 1.9-6.073 1.563-1.747-.719-4.1s-.645-1.774-1.171-1.523-2.461 2.335-4.274 2.517-2.879.406-3.3 0-.174-.853-.535-3.164z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 391",
  d: "M138.524 121.095a9.975 9.975 0 01-1.858-.364 12.962 12.962 0 00-3.054-.054s-2.761.17-3.27.967-2.707 5.111-3.46 5.382-5.2 7.436-6.115 8.066-4.833 8.315-4.833 8.315 2.9-1.368 4.225.635c.034.052.069.1.1.16 1.275 2.234 2.461.512 2.461.512a57.175 57.175 0 004.557-4.513c.337-.669 2.832-5.7 3.474-7.094s6.08-8.258 6.262-8.563 1.511-3.449 1.511-3.449z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 392",
  d: "M138.524 121.095a15.567 15.567 0 01-2.187-.463 12.982 12.982 0 00-3.056-.054s-2.761.17-3.27.965-2.707 5.113-3.46 5.382-5.2 7.436-6.115 8.069-4.833 8.315-4.833 8.315 2.9-1.368 4.227.635c.032.049.066.1.1.16 1.275 2.232 2.461.512 2.461.512a57.176 57.176 0 004.557-4.513c.335-.667 2.832-5.7 3.474-7.094s6.08-8.258 6.262-8.566 1.84-3.348 1.84-3.348z",
  fill: "#4c4981"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 393",
  d: "M146.603 121.351s3.489 2.532 3.937 3.3 5.017 3.169 5.017 3.169 1.723 3.179 1.464 4.323a6.4 6.4 0 00-.308 2.845c.224.61.362.605.029 1.41s-.216.883.246 1.607-6.89 2.953-6.89 2.953-.984.153-1.09.623-5.743 12.874-6.558 14.845-3.388 9.843-5.549 9.953-.492.03-.492.03.332-6.4-1-8.612 1.294-10.761 1.294-10.761 8.738-25.129 9.9-25.685z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 394",
  d: "M146.603 121.351s3.821 2.633 4.269 3.4 5.03 3.169 5.03 3.169 1.723 3.179 1.464 4.323a6.4 6.4 0 00-.308 2.845c.224.608.362.605.03 1.41s-.219.883.246 1.609-6.89 2.953-6.89 2.953-.984.155-1.09.623-5.755 12.879-6.575 14.848-3.388 9.83-5.549 9.946-.492.03-.492.03.332-6.4-1-8.612 1.316-10.765 1.316-10.765 8.387-25.223 9.549-25.779z",
  fill: "#4c4981"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 395",
  d: "M151.037 146.679s-7.741 1.722-7.982 2.215-6.644 4.309-3.285 6.152 8.637-2.6 8.637-2.6l4.183-2.67z",
  fill: "#fec2be"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 396",
  d: "M154.496 136.359c.126.037 2.822 1.747 2.822 1.747s1.27 4.218 1.548 5.251a30.546 30.546 0 01.938 3.216c-.047.344.768 2.261-.531 3.137s-2.662.738-3.287 1.324a34.063 34.063 0 01-5.477 2.608c-.544.148 2.687-6.425-1.3-7.436 0 0 2.857.268 3-.231s.312-1.8-.221-2.279-2.84-2.746-2.84-2.746z",
  fill: "#4c4981"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 397",
  d: "M151.226 114.823a1.777 1.777 0 01-.77-.807c-.263-.512-.527-1.137-1.088-1.267-.315-.076-.7.017-.93-.207a.984.984 0 01-.18-.719 2.924 2.924 0 00-.47-1.631 1.708 1.708 0 00-1.459-.76c-.8.054-1.5.783-2.284.637-.347-.064-.679-.3-1.019-.207a1 1 0 00-.359.2 5.234 5.234 0 00-1.641 2.215c-.325.827-.433 1.722-.822 2.532-.155.315-.453.652-.787.554-.522-.155-.246-.812-.536-1.1a.8.8 0 00-.411-.165 6.449 6.449 0 1112.756.723z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 398",
  d: "M139.471 115.197c.335.1.632-.246.787-.551.389-.8.492-1.705.822-2.532a5.224 5.224 0 011.644-2.215 1 1 0 01.357-.2c.34-.089.674.143 1.019.207.787.148 1.476-.583 2.284-.637a1.708 1.708 0 011.459.763 2.889 2.889 0 01.47 1.629.982.982 0 00.182.719c.231.226.613.133.93.207.561.133.822.755 1.088 1.267s.8 1.048 1.334.827a5.131 5.131 0 01.455-.246c.3-.1.664.064.935-.1.344-.212.246-.738.022-1.09s-.492-.738-.352-1.115a1.512 1.512 0 01.372-.477 2.365 2.365 0 00-.143-3.246c-.219-.2-.475-.349-.689-.551a7.249 7.249 0 01-.984-1.476 4.5 4.5 0 00-1.567-1.476 2.239 2.239 0 00-.91-.317 7.69 7.69 0 00-1.329.177c-1.491.15-2.773-1.029-4.232-1.363a1.2 1.2 0 00-1 .118c-.29.226-.352.632-.492.984a2.957 2.957 0 01-1.755 1.57c-.869.332-1.969.512-2.33 1.366-.315.738.093 1.585-.071 2.362a4.757 4.757 0 01-.935 1.595 1.719 1.719 0 00-.305 1.742 1.55 1.55 0 00.8.623c.408.167 1.319.079 1.594.349s.019.933.54 1.087z",
  fill: "#9a5e7f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 399",
  d: "M154.048 143.753c.148.015 2.837.492 3.47 1.4s-3.47-1.4-3.47-1.4z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 400",
  d: "M152.702 140.884a21.667 21.667 0 013.273.947c.339.283-3.273-.947-3.273-.947z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 401",
  d: "M153.667 133.642s2.158.945 2.4 1.531-2.4-1.531-2.4-1.531z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 402",
  d: "M126.088 158.109c.224.157 5.524 4.09 5.091 4.232s-5.091-4.232-5.091-4.232z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 403",
  d: "M126.048 160.569s3.105 1.5 2.586 2.128-2.586-2.128-2.586-2.128z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 70",
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 404",
  d: "M137.886 109.458c.14-.667-.14-1.388-.025-2.042v.01c-.31.719.081 1.558-.064 2.325a2.059 2.059 0 00.089-.293z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 405",
  d: "M153.005 111.784a.633.633 0 00-.034.2 2.726 2.726 0 01.308-.347 2.145 2.145 0 00.519-1.019 2.083 2.083 0 01-.421.687 1.511 1.511 0 00-.372.479z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 406",
  d: "M153.337 113.989c-.271.167-.635 0-.937.1-.165.057-.3.185-.455.246-.534.221-1.07-.312-1.334-.824s-.527-1.137-1.088-1.27c-.315-.074-.7.02-.93-.207a.987.987 0 01-.182-.716 2.916 2.916 0 00-.468-1.631 1.722 1.722 0 00-1.462-.763c-.8.054-1.494.785-2.281.64-.347-.066-.682-.3-1.021-.209a1.036 1.036 0 00-.357.2 5.224 5.224 0 00-1.644 2.215 7.451 7.451 0 00-.246.721c.042-.13.086-.261.138-.389a5.224 5.224 0 011.644-2.215 1 1 0 01.357-.2c.34-.089.674.143 1.019.207.787.148 1.476-.583 2.284-.637a1.708 1.708 0 011.459.763 2.89 2.89 0 01.47 1.629.982.982 0 00.182.719c.231.226.613.133.93.207.561.133.822.755 1.088 1.267s.8 1.048 1.334.827a5.123 5.123 0 01.455-.246c.3-.1.664.064.935-.1a.492.492 0 00.221-.443.435.435 0 01-.111.109z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 407",
  d: "M140.357 114.308c-.153.315-.453.65-.787.551-.522-.153-.246-.81-.534-1.1s-1.186-.182-1.595-.349a1.56 1.56 0 01-.8-.623 1.179 1.179 0 01-.1-.834 1.347 1.347 0 000 1.166 1.55 1.55 0 00.8.623c.408.167 1.319.079 1.595.349s.012.945.534 1.1c.335.1.632-.246.787-.551a6.43 6.43 0 00.381-1.063 5.278 5.278 0 01-.278.731z"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 408",
  d: "M129.378 126.686s-2.119 3.162-1.865 3.824 1.865-3.824 1.865-3.824z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 409",
  d: "M129.688 136.989a5.939 5.939 0 011.535.91c.411.441-1.535-.91-1.535-.91z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 410",
  d: "M132.158 140.212s2.4.581 2.606.957-2.606-.957-2.606-.957z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 411",
  d: "M132.576 143.5s2.173.285 2.419 1.127-2.419-1.127-2.419-1.127z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 412",
  d: "M205.041 180.904c-.416 3.952-3.223 3.327-3.223 3.327l-.524-.047a5.307 5.307 0 01-.827-2.968 4.984 4.984 0 011.11-3.322c1.948.405 3.649 1.256 3.464 3.01z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 413",
  d: "M124.705 129.127c-4.747 0-8.593 5.2-8.593 11.612s3.846 11.609 8.593 11.609 8.6-5.2 8.6-11.609-3.851-11.612-8.6-11.612zm-1.213 20.8c-3.617 0-6.548-3.77-6.548-8.423s2.931-8.42 6.548-8.42 6.55 3.77 6.55 8.42-2.93 8.418-6.55 8.418z",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 414",
  d: "M125.121 144.309l4.021 3.949 1.454-3.536-5.822-3.4z",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 415",
  d: "M131.049 105.204l3.5.426 1.3 1.543-1.969 8.858-4.183 14.272-2.746 9.8-1.929 5.95-1.23 7.874-1.23 5.414-3.691 3.691-7.505-8.858-1.23-2.953-2.953-6.029 7.628-3.568 8.366-.738 3.937-10.089 3.2-11.688z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 416",
  d: "M60.238 147.427l-4.574 38.4 57.6-2.426-6.654-18.854-11.09-7.21 25.37.416.138-10.534L110.769 145l-20.655-1.663-15.527-.691-14.833 4.85",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 417",
  d: "M60.238 147.427l-4.574 38.4 57.6-2.426-6.654-18.854-11.09-7.21 25.37.416.138-10.534L110.769 145l-20.655-1.663-15.527-.691-14.833 4.85",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 418",
  d: "M138.937 185.695c0 9.542-3.172 18.229-11.969 17.279-11.1-.246-11.966-7.736-11.966-17.279s5.357-16.644 11.966-16.644 11.969 7.101 11.969 16.644z",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 419",
  d: "M139.006 185.713c0-7.382-3.211-13.312-7.729-15.611-5.8 1.1-10.261 7.776-10.261 16.487 0 7.82.586 14.272 6.9 16.469 8.132.288 11.09-8.13 11.09-17.345z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 420",
  d: "M150.238 170.719l-3.383 3.876 6.09-1.046 4.552-4.183 4.06-8.12 5.721-3.507 14.026 1.907 12.98.492 4.791-4.255-5.345-.728-5.413-.123-13.6-.308-16.179-.431-3.322 8.858-2.522 6.09z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 421",
  d: "M196.793 186.522c-.278.416-9.351 1.8-9.351 1.8l-25.1 4.574-43.101.626-5.059-4.3-2.658.472-.108.02-35.5 6.3-.578-.081-9.675-1.38-50.535-7.2.566-7.335.335-4.331.691-8.989.492-2.357 4.5-.413 2.1-.192 32.8-3.009 4.289-.394 2.4-.219 23.428-3.2 34.171.832.138-10.537 13.515-41.587c2.98.492 2.911 2.5 2.911 2.5l-11.509 39.164-.14 24.053c23.93 2.416 24.7-2.8 28.487-1.041l4.577-14.624 40.2.209c1.607 1.939-2.286 30.639-2.286 30.639z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 422",
  d: "M97.049 164.686l12.754 27.38 4.3 1.385 1.041-4.437-4.784-15.18-4.921-8.8z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 423",
  d: "M97.049 164.686l12.754 27.38 4.3 1.385 1.041-4.437-4.784-15.18-4.921-8.8z",
  opacity: 0.15
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 46",
  cx: 23.098,
  cy: 26.201,
  rx: 23.098,
  ry: 26.201,
  transform: "translate(65.648 168.635)",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 424",
  d: "M96.988 170.272c-12.087.841-21.654 12.225-21.654 26.147 0 11.223 6.221 20.8 14.963 24.528 12.087-.841 21.654-12.225 21.654-26.147.003-11.223-6.22-20.798-14.963-24.528z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 425",
  d: "M26.834 149.021l-1.144 5.4-3.504 16.51-15.042-1.457s-.9-2.771 1.457-3.812c0 0 .773-9.383 3.553-12.338a2.8 2.8 0 011.09-.76z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 426",
  d: "M25.686 154.418l-3.5 16.513-15.042-1.457s-.9-2.771 1.457-3.812c0 0 .773-9.383 3.553-12.338z",
  fill: "#fff",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 427",
  d: "M60.73 150.481c1.939 3.253-2.763 33.266-2.763 33.266l-36.954-6.1 1.316-26.27c.763-4.712 3.536-5.266 3.536-5.266 13.042-6.585 42.973-7.973 42.973-7.973 27.314 1.038 52.193 9.08 52.193 9.08-31.051-4.781-60.301 3.263-60.301 3.263z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 428",
  d: "M57.967 183.747l-36.954-6.1 1.316-26.27c.763-4.712 3.536-5.266 3.536-5.266s26.962-2.566 34.865 4.37c1.939 3.253-2.763 33.266-2.763 33.266z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 429",
  d: "M54.051 182.014l-30.891-5.2 1.095-22.414c.637-4.021 2.953-4.493 2.953-4.493s22.545-2.19 29.152 3.725c1.631 2.774-2.309 28.382-2.309 28.382z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 47",
  cx: 4.227,
  cy: 7.695,
  rx: 4.227,
  ry: 7.695,
  transform: "translate(47.282 155.882)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 48",
  cx: 4.227,
  cy: 7.695,
  rx: 4.227,
  ry: 7.695,
  transform: "translate(47.282 155.675)",
  fill: "#dce0ed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 430",
  d: "M52.06 157.685s-1.722.276-.832 2.564a16.556 16.556 0 011.038 3.465s1.722.9 1.663-2.079-1.869-3.95-1.869-3.95z",
  fill: "#f0f0f4"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 49",
  cx: 3.952,
  cy: 7.19,
  rx: 3.952,
  ry: 7.19,
  transform: "translate(24.892 153.337)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 50",
  cx: 3.952,
  cy: 7.19,
  rx: 3.952,
  ry: 7.19,
  transform: "translate(24.892 153.128)",
  fill: "#dce0ed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 431",
  d: "M29.398 154.634s-1.723.278-.832 2.566a16.7 16.7 0 011.041 3.465s1.722.9 1.663-2.079-1.872-3.952-1.872-3.952z",
  fill: "#f0f0f4"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 432",
  d: "M46.647 157.06c-.276 2.842-1.663 23.913-1.663 23.913l-2.352-.394-1.307-.214-1.742-.293-.212-.034-6.863-1.144 1.356-22.35a2.8 2.8 0 012.84-2.618 1.993 1.993 0 01.209 0c.475.042.984.091 1.518.15.224.025.453.049.682.079.659.079 1.341.175 2.008.283.34.059.674.121 1.006.185.559.111 1.1.234 1.6.374.337.094.659.194.955.305 1.239.447 2.049 1.025 1.965 1.758z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 433",
  d: "M36.703 153.925l-1.344 25.1-.763-.069 1.331-24.954a2.777 2.777 0 01.776-.077z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 434",
  d: "M39.112 154.152l-1.257 25.365h-1.179l1.754-25.446c.224.027.453.052.682.081z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 435",
  d: "M42.127 154.619l-1.983 25.453h-.765v-.034l1.74-25.591c.341.047.675.108 1.008.172z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 436",
  d: "M44.678 155.298l-2.04 25.281v.049l-1.316-.14v-.123l2.392-25.372a10 10 0 01.964.305z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 437",
  d: "M16.489 174.876s-2.547-13.152 3.275-13.829 24.954.738 24.38 6.134-1.189 13.62-1.189 13.62l-3.949-.883s2.953-12.372-1.663-12.84-15.96-1.769-15.96-1.769-3.068-.519-1.3 10.335z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 438",
  d: "M16.489 176.123s-2.547-13.984 3.275-14.661 24.954.738 24.38 6.134-1.189 13.62-1.189 13.62l-3.949-.883s2.953-12.372-1.663-12.84-15.967-1.757-15.967-1.757-3.068.313-1.3 11.179z",
  fill: "#dce0ed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 439",
  d: "M119.238 193.52l-5.128-.069c-3.743-16.486-9.911-26.754-9.911-26.754-2.087-1.11-24.821-.96-24.821-.96-2.357.416-2.98 7.9-2.98 7.9s2.01 1.723.069 2.842c-.866.492-3.721.588-7.008.418a55.451 55.451 0 01-11.29-1.6c-4.429-1.388-.9-3.952-.9-3.952s.625-.832 1.041-5.414a18.517 18.517 0 012.53-7.552c.192-.317.313-.492.313-.492a2.376 2.376 0 01.81-.507c5.876-2.461 34.678-.118 34.678-.118l10.674 3.4c.3.118.751.871 1.312 2.074 3.366 7.238 10.611 30.784 10.611 30.784z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 440",
  d: "M119.238 193.52l-5.128-.069c-3.743-16.486-9.911-26.754-9.911-26.754-2.087-1.11-24.821-.96-24.821-.96-2.357.416-2.98 7.9-2.98 7.9s2.01 1.723.069 2.842c-.866.492-3.721.588-7.008.418a55.451 55.451 0 01-11.29-1.6c-4.429-1.388-.9-3.952-.9-3.952s.625-.832 1.041-5.414a18.517 18.517 0 012.53-7.552c.192-.317.313-.492.313-.492a2.376 2.376 0 01.81-.507c5.876-2.461 34.678-.118 34.678-.118l10.674 3.4c.3.118.751.871 1.312 2.074 3.366 7.238 10.611 30.784 10.611 30.784z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 441",
  d: "M108.619 162.74c-9.843-3.829-37.009-1.8-37.009-1.8-2.884-2.461-8.31-2.628-10.778-2.562.192-.317.313-.492.313-.492a2.374 2.374 0 01.81-.507c5.876-2.461 34.678-.118 34.678-.118l10.674 3.4c.296.119.751.875 1.312 2.079z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 442",
  d: "M73.205 161.982a3272.3 3272.3 0 01-3.182 10.746 36.381 36.381 0 00-.564 4.161 55.448 55.448 0 01-11.29-1.6c-4.429-1.388-.9-3.952-.9-3.952s.625-.832 1.041-5.414a18.423 18.423 0 012.842-8.041 2.374 2.374 0 01.81-.507c3.846.918 11.715 2.98 11.243 4.607z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 443",
  d: "M73.205 161.982a3272.3 3272.3 0 01-3.182 10.746 36.381 36.381 0 00-.564 4.161 55.448 55.448 0 01-11.29-1.6c-4.429-1.388-.9-3.952-.9-3.952s.625-.832 1.041-5.414a18.423 18.423 0 012.842-8.041 2.374 2.374 0 01.81-.507c3.846.918 11.715 2.98 11.243 4.607z",
  fill: "#fff",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 444",
  d: "M79.549 107.396c-2.756.416-3.952 6.134-3.952 6.134l-7.485 25.005 52.919 8.681 13.517-41.585c-12.424-5.617-54.999 1.765-54.999 1.765zm42.57 26.721s-.313 2.392-2.34 2.6l-34.309-1.341-7.038-.278-2.36-.091h-.167s-2.6.468-2.185-1.722c0 0 2.859-20.793 7.9-22.353 0 0 .524-.111 1.442-.283 1.442-.273 3.849-.7 6.683-1.093 1.27-.175 2.626-.342 4.021-.492a60.417 60.417 0 0111.3-.271s25.264-2.34 23.445 3.275c0 .007-5.3 20.333-6.39 22.048z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 445",
  d: "M76.076 135.007h-.167s-2.6.468-2.185-1.722c0 0 2.859-20.793 7.9-22.353 0 0 .524-.111 1.442-.283-1.827 3.57-7.703 15.805-6.99 24.358z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 446",
  d: "M76.076 135.007h-.167s-2.6.468-2.185-1.722c0 0 2.859-20.793 7.9-22.353 0 0 .524-.111 1.442-.283-1.827 3.57-7.703 15.805-6.99 24.358z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 447",
  d: "M80.735 186.296a3.347 3.347 0 01-3.132 1.757l-1.061-.047-9.993-.431-3.6-.155-3.327-.276-43.933-7.136.335-4.331 5.052.723 2.092.3 31.017 4.429 4.082.6 1.981.283 8.388-.062 9.08-.066a3.415 3.415 0 011.339.246 3.255 3.255 0 011.759 1.671 2.734 2.734 0 01-.076 2.493z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 448",
  d: "M80.735 186.712a3.347 3.347 0 01-3.132 1.757l-14.656-.632-3.327-.278-46.851-7.6-3.691-.6-2-.335c-3.949-.832-2.771-4.784-2.771-4.784.276-1.8 7.07-3.467 9.287-3.4 1.491.047 1.7 2.343 1.673 3.846a9.916 9.916 0 01-.079 1.282l2.192.315 42.863 6.132 17.471-.128a3.356 3.356 0 013.1 1.929 2.734 2.734 0 01-.079 2.496z",
  fill: "#dce0ed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 449",
  d: "M10.406 173.35a8.049 8.049 0 004.784 2.633 5.238 5.238 0 00-4.784-2.633z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 450",
  d: "M9.922 179.797s-6.169-.14-6.169 3.2 3.883 3.883 3.883 3.883l55.1 10.6 15.665.276s5.475-4.365-.209-6.307l-15.8.408-52.539-9.633s1.385-1.873.069-2.427z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 451",
  d: "M78.405 198.163l-15.665-.276-49-9.429-3.585-.691-2.522-.492s-3.883-.556-3.883-3.883c0-2.387 3.179-2.99 4.973-3.14.706-.057 1.2-.047 1.2-.047 1.316.554-.069 2.424-.069 2.424l1.912.352 50.631 9.292 15.8-.416c5.683 1.931.208 6.306.208 6.306z",
  fill: "#dce0ed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 452",
  d: "M14.565 177.093l3.258-1.457 1.663-.069-.138 14-5.128-1.038-2.149-1.385-1.038-5.822a15.841 15.841 0 01.623-2.633c.204-.206 2.909-1.596 2.909-1.596z",
  fill: "#dce0ed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 453",
  d: "M14.565 177.093l3.258-1.457 1.663-.069-.138 14-5.128-1.038-2.149-1.385-1.038-5.822a15.841 15.841 0 01.623-2.633c.204-.206 2.909-1.596 2.909-1.596z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 454",
  d: "M13.748 188.459l.059.071-3.6-.694-.042-.069c-1.9-3.064-2.062-5.544-1.432-7.512.706-.057 1.2-.047 1.2-.047 1.316.554-.069 2.424-.069 2.424l1.912.352a8.781 8.781 0 001.972 5.475z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 455",
  d: "M19.072 175.579a18.446 18.446 0 00-1.69.738 11.027 11.027 0 00-4.614 3.659l-3.691-.6a11.242 11.242 0 015.413-4.833l.773.175z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 456",
  d: "M14.901 174.529s-10.118 4.021-4.3 13.307l3.6.694s-7.136-8.179 5.266-12.963z",
  fill: "#dce0ed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 457",
  d: "M39.034 179.034l3.743-.138-.625 15.04-6.031-1.107-2.564-1.248-1.179-2.982-.832-2.98 2.01-2.7 2.288-1.523z",
  fill: "#dce0ed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 458",
  d: "M39.034 179.034l3.743-.138-.625 15.04-6.031-1.107-2.564-1.248-1.179-2.982-.832-2.98 2.01-2.7 2.288-1.523z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 51",
  cx: 1.801,
  cy: 3.049,
  rx: 1.801,
  ry: 3.049,
  transform: "translate(36.817 183.749)",
  fill: "#dce0ed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 459",
  d: "M25.534 195.304a4.012 4.012 0 00-2.547-3.223s-3.9-1.142-4 3.184c0 0 .052 2.653 1.821 3.484l.1 2.953s.155 2.756-1.405 2.5-1.351-2.707-1.351-2.707-.832-2.6-2.859-1.248a2.042 2.042 0 00.573 2.185 2 2 0 01.541 1.939 2.82 2.82 0 00.65 2.259 2.62 2.62 0 002.5.9 3.878 3.878 0 002.165-1.245 5.68 5.68 0 001.5-3.787l.076-3.8s2.756-.742 2.236-3.394zm-3.2 2.677a3.035 3.035 0 100-.01z",
  fill: "#dce0ed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 460",
  d: "M21.43 190.937a.984.984 0 00-.492 1.366 6.854 6.854 0 01.851 2.015c-.079.44.91.079 1.038-.027s1.924 0 2.028-1.23a2.1 2.1 0 00-.96-1.873l.416-2.677-2.461-.207.027 2.443z",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 461",
  d: "M21.43 190.937a.984.984 0 00-.492 1.366 6.854 6.854 0 01.851 2.015c-.079.44.91.079 1.038-.027s1.924 0 2.028-1.23a2.1 2.1 0 00-.96-1.873l.416-2.677-2.461-.207.027 2.443z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 462",
  d: "M22.104 190.887s.832 2.859.468 2.953-.468-2.953-.468-2.953z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 463",
  d: "M23.039 190.211s.832 2.859.468 2.953-.468-2.953-.468-2.953z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 464",
  d: "M33.005 181.598l-1.388 8.6s-1.722-.234-2.662-.438a1.922 1.922 0 01-.6-.185c-.049-.049-.15-.044-.285-.017-.463.094-1.284.475-1.444.153a.228.228 0 00-.047-.066c-.162-.177-.477-.049-.782 0a.664.664 0 01-.492-.064c-.246-.172-.775.1-1.2.194-.268.059-.492.047-.605-.194a.559.559 0 00-.413-.3c-.4-.1-.957-.032-1.28-.1a.292.292 0 01-.246-.16c-.064-.187-.421-.276-.8-.349-.465-.089-.965-.155-1-.342 0-.064-.057-.091-.125-.094a4.294 4.294 0 00-.758.187c-.207.054-.381.054-.431-.094s-.293-.148-.566-.081c-.219.054-.463.14-.65.185s-.29.044-.31-.037c-.069-.276-.97.349-1.176-.207s-3.056-4.242.635-9.016c0 0 .984.069 1.752.207a2.748 2.748 0 01.738.207 4.237 4.237 0 001.336.155 1.724 1.724 0 01.738.177.492.492 0 01.209.221c.116.263.381.317.672.3.394-.025.832-.172.984-.094h.015c.29.125 1.378 0 1.563.185l.015.017c.079.116.492 0 .94-.064a1.052 1.052 0 01.861.135.94.94 0 00.674.2 3.969 3.969 0 01.883.034.377.377 0 01.175.111c.175.219.6.189.984.209a1 1 0 01.551.138.515.515 0 00.2.084 5.926 5.926 0 001.671-.084z",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 465",
  d: "M17.882 188.239c-.219.054-.463.14-.65.185a6.845 6.845 0 01.888-9.048 2.748 2.748 0 01.738.207c-2.831 3.265-1.517 7.34-.976 8.656z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 466",
  d: "M19.639 188.23a4.294 4.294 0 00-.758.187 6.846 6.846 0 011.321-8.674 1.723 1.723 0 01.738.177c-2.694 2.948-1.894 6.617-1.301 8.31z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 467",
  d: "M21.812 189.175a.292.292 0 01-.246-.16c-.064-.187-.421-.276-.8-.349a6.747 6.747 0 011.058-8.221c.394-.025.832-.172.984-.093h.015c-2.975 3.348-1.535 7.579-1.011 8.823z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 468",
  d: "M24.112 189.765c-.268.059-.492.047-.605-.194a.559.559 0 00-.413-.3 6.857 6.857 0 011.3-8.735l.015.017c.079.116.492 0 .94-.064-3.503 3.54-1.702 8.234-1.237 9.276z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 469",
  d: "M26.577 189.638c-.162-.177-.477-.049-.782 0a6.829 6.829 0 011.09-8.807 3.965 3.965 0 01.883.034c-2.999 3.226-1.761 7.338-1.191 8.773z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 470",
  d: "M28.955 189.755a1.918 1.918 0 01-.6-.185c-.049-.049-.15-.044-.285-.017a6.736 6.736 0 01.846-8.366 1 1 0 01.551.138.516.516 0 00.2.084c-2.486 3.208-1.229 7.077-.712 8.346z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 52",
  cx: 11.297,
  cy: 16.634,
  rx: 11.297,
  ry: 16.634,
  transform: "translate(84.852 179.452)",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 53",
  cx: 8.214,
  cy: 13.482,
  rx: 8.214,
  ry: 13.482,
  transform: "translate(87.553 182.846)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 54",
  cx: 8.214,
  cy: 13.482,
  rx: 8.214,
  ry: 13.482,
  transform: "translate(87.553 182.43)",
  fill: "#f0f0f4"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 55",
  cx: 0.97,
  cy: 1.663,
  rx: 0.97,
  ry: 1.663,
  transform: "translate(96.286 185.203)",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 56",
  cx: 0.97,
  cy: 1.663,
  rx: 0.97,
  ry: 1.663,
  transform: "translate(100.169 199.76)",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 57",
  cx: 0.97,
  cy: 1.663,
  rx: 0.97,
  ry: 1.663,
  transform: "translate(89.702 192.829)",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 58",
  cx: 0.97,
  cy: 1.663,
  rx: 0.97,
  ry: 1.663,
  transform: "translate(92.544 202.531)",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 471",
  d: "M178.84 165.308s8.12 21.627 7.695 22.978c0 0 3.43 2.079 4.262 1.56s.106-10.089.106-10.089l-1.56-8.42-1.769-4.99z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 472",
  d: "M178.84 165.308s8.12 21.627 7.695 22.978c0 0 3.43 2.079 4.262 1.56s.106-10.089.106-10.089l-1.56-8.42-1.769-4.99z",
  opacity: 0.15
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 59",
  cx: 0.97,
  cy: 1.663,
  rx: 0.97,
  ry: 1.663,
  transform: "translate(101.555 190.749)",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 60",
  cx: 2.842,
  cy: 3.952,
  rx: 2.842,
  ry: 3.952,
  transform: "translate(94.414 192.479)",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 473",
  d: "M187.892 194.215c0 12.518-4.159 23.913-15.7 22.665-14.555-.312-15.7-10.148-15.7-22.665s7.023-21.834 15.694-21.834 15.706 9.314 15.706 21.834z",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 474",
  d: "M187.976 194.234c0-9.69-4.213-17.471-10.14-20.478-7.611 1.447-13.46 10.2-13.46 21.622 0 10.259.77 18.7 9.058 21.6 10.662.388 14.542-10.64 14.542-22.744z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 475",
  d: "M194.02 188.911s-2.079 1.767-3.224.519c0 0-2.808-22.459-6.341-22.562l-12.166-.1s-1.454.623-2.079 3.327l-7.874 22.392-43.1.62-3.292-6.89 35.663.1v-.015c.192-.691 6.152-21.969 10.155-24.607a1.719 1.719 0 01.44-.214s14.867-1.969 19.754-.625c0 0 5.094 1.144 6.341 2.707.167.175 2.1 2.347 2.694 8.612z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 476",
  d: "M194.02 189.327s-2.079 1.767-3.224.519c0 0-2.808-22.459-6.341-22.562l-12.166-.1s-1.454.623-2.079 3.327l-7.874 22.392-43.1.62-3.292-6.89 35.663.1v-.015c.192-.691 6.152-21.969 10.155-24.607a1.721 1.721 0 01.44-.214s14.867-1.969 19.754-.625c0 0 5.094 1.144 6.341 2.707v.012c.167.175 2.1 2.348 2.694 8.612z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 477",
  d: "M194.02 189.327s-2.079 1.767-3.224.519c0 0-2.808-22.459-6.341-22.562l-12.166-.1s-1.454.623-2.079 3.327l-7.874 22.392-43.1.62-3.292-6.89 35.663.1v-.015c.192-.691 6.152-21.969 10.155-24.607a1.721 1.721 0 01.44-.214s14.867-1.969 19.754-.625c0 0 5.094 1.144 6.341 2.707v.012c.167.175 2.1 2.348 2.694 8.612z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 478",
  d: "M167.612 164.79c-1.041 1.969-9.98 26.3-9.98 26.3l-6.031-4.368v-.015c.192-.691 6.152-21.991 10.16-24.607 2.607.438 6.557 1.348 5.851 2.69z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 479",
  d: "M155.968 153.665l-4.887 16.009-25.473-.738.207 2.392s19.964 2.911 28.487-1.041l4.577-14.624 40.2.207-7.658-1.8z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 480",
  d: "M155.968 153.665l-4.887 16.009-25.473-.738.207 2.392s19.964 2.911 28.487-1.041l4.577-14.624 40.2.207-7.658-1.8z",
  fill: "#fff",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 481",
  d: "M36.539 178.894s-13.654 6.863-3.536 13.31l2.707.623s-9.912-7.136 6.644-13.932z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 482",
  d: "M36.954 178.894s-13.654 6.863-3.536 13.31l2.707.623s-9.912-7.136 6.644-13.932z",
  fill: "#dce0ed"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 61",
  cx: 7.589,
  cy: 12.997,
  rx: 7.589,
  ry: 12.997,
  transform: "translate(170.626 182.984)",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 62",
  cx: 5.517,
  cy: 10.532,
  rx: 5.517,
  ry: 10.532,
  transform: "translate(172.442 185.73)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 63",
  cx: 5.517,
  cy: 10.532,
  rx: 5.517,
  ry: 10.532,
  transform: "translate(172.442 185.314)",
  fill: "#f0f0f4"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 64",
  cx: 0.652,
  cy: 1.299,
  rx: 0.652,
  ry: 1.299,
  transform: "translate(178.308 187.479)",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 65",
  cx: 0.652,
  cy: 1.299,
  rx: 0.652,
  ry: 1.299,
  transform: "translate(180.917 198.852)",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 66",
  cx: 0.652,
  cy: 1.299,
  rx: 0.652,
  ry: 1.299,
  transform: "translate(173.884 193.437)",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 67",
  cx: 0.652,
  cy: 1.299,
  rx: 0.652,
  ry: 1.299,
  transform: "translate(175.793 201.018)",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 68",
  cx: 0.652,
  cy: 1.299,
  rx: 0.652,
  ry: 1.299,
  transform: "translate(181.847 191.812)",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 69",
  cx: 1.909,
  cy: 3.086,
  rx: 1.909,
  ry: 3.086,
  transform: "translate(177.051 193.166)",
  fill: "#636780"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 483",
  d: "M68.006 138.177s23.084.832 53.025 9.045z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 484",
  d: "M178.134 97.765s-1.253.2-.6 1.855a11.837 11.837 0 01.76 2.507s1.255.652 1.2-1.506a3.211 3.211 0 00-1.36-2.856z",
  fill: "#dce0ed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 485",
  d: "M116.737 131.287l-.015.02a2.348 2.348 0 00-.492 1.134c-.2 1.314-.394 4.006 1.518 3.561a5.905 5.905 0 002.849-1.548 2.335 2.335 0 00.632-1.722 1.8 1.8 0 00-.79-1.5l-.711-.409a1.231 1.231 0 00-.664-.172l-1.23.044a1.536 1.536 0 00-1.1.593z",
  fill: "#fec2be"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 486",
  d: "M130.557 108.772l-3.675 18.253-2.6 5.492 1.722 3.2 3.814-8.982s4.183-13.165 4.183-13.534a46.289 46.289 0 00-3.444-4.429z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 70",
  cx: 17.5,
  cy: 17.5,
  r: 17.5,
  transform: "translate(172 28.598)",
  fill: "#fcf9a3"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 540",
  d: "M46.865 122.203a4.082 4.082 0 00.54-2.07c0-1.871-1.156-3.388-2.587-3.388s-2.587 1.517-2.587 3.388a4.081 4.081 0 00.54 2.07 4.24 4.24 0 000 4.141 4.24 4.24 0 000 4.141 4.24 4.24 0 000 4.141c-.361.63-.547 5.366-.54 6.091 0 1.871 2.422 0 3.853 0s1.321-2.15 1.321-4.021a4.076 4.076 0 00-.54-2.069 4.24 4.24 0 000-4.141 4.24 4.24 0 000-4.141 4.24 4.24 0 000-4.141z",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 541",
  d: "M34.051 78.514a14.514 14.514 0 01-1.108-1.634l7.823-1.284-8.461.063a14.29 14.29 0 01-.272-11.3l11.351 5.889-10.469-7.7a14.265 14.265 0 1123.556 15.957 14.327 14.327 0 011.626 2.6l-10.154 5.281 10.828-3.634a14.278 14.278 0 01-2.3 13.395 14.263 14.263 0 11-22.416 0 14.271 14.271 0 010-17.637z",
  fill: "#57b894"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 542",
  d: "M59.531 87.332a14.208 14.208 0 01-3.051 8.818 14.263 14.263 0 11-22.416 0c-1.925-2.427 25.467-10.419 25.467-8.818z",
  opacity: 0.1
}))));
export default SvgUndrawOffRoad3;